export const viewQueryKeys = {
  viewTPA: {
    all: () => ['view-tpa'] as const,
    details: (viewId: number) => ['view-tpa', 'details', viewId] as const,
    list: (roadmapId: number) => ['view-tpa', 'list', roadmapId] as const,
    unlockPreview: (viewId: number) => ['view-tpa', 'unlockPreview', viewId] as const,
  },
  visualizationsView: {
    all: () => ['visualizationsView'] as const,
    details: (viewId: number) => ['visualizationsView', 'details', viewId] as const,
    list: (loopId: number) => ['visualizationsView', 'list', loopId] as const,
    unlockPreview: (viewId: number) => ['visualizationsView', 'unlockPreview', viewId] as const,
  },
  portfolioView: {
    detail: (loopId: number) => ['portfolioView', 'detail', loopId] as const,
  },
  scenarioView: {
    detail: (loopId: number) => ['scenarioView', 'detail', loopId] as const,
  },
  visualizations: {
    all: (loopId: number, viewId: number) => ['loop-view-visualizations', loopId, viewId] as const,
  },
  filter: {
    list: (viewId: number) => ['filters', viewId],
    detail: (viewId: number, fieldId: string) => ['filter', viewId, fieldId],
  },
  dateSource: {
    detail: (viewId: number) => ['view-date-source', viewId] as const,
  },
};
